<template>
  <div>
    <div class="section-container">
      <div class="search-section">
        <h6 class="mt-3 mb-0">
          <strong>กรุณาระบุช่วงเวลาที่ต้องการดาวน์โหลดรายงาน</strong>
        </h6>
        <b-row class="date-section">
          <b-col cols="3">
            <label><strong>วันที่ลงทะเบียน</strong></label>
            <div class="date-range-field">
              <b-input-group>
                <b-form-input
                  size="sm"
                  type="text"
                  :value="formatDate"
                  placeholder="เลือกวันที่ลงทะเบียน"
                  disabled
                />
                <b-input-group-prepend>
                  <b-button
                    size="sm"
                    variant="secondary"
                    @click="showCalendarRange(`calendar-range-${tabIndex}`)"
                  >
                    <b-icon icon="calendar-range"></b-icon>
                  </b-button>
                </b-input-group-prepend>
              </b-input-group>
              <DatePicker
                v-model="dateRange"
                locale="th"
                :id="`calendar-range-${tabIndex}`"
                is-range
                style="
                  display: none;
                  float: right;
                  position: relative;
                  will-change: transform;
                  left: 0px;
                "
              >
                <!-- Override calendar header title -->
                <template #header-title="{ monthLabel, year }">
                  <span>{{ monthLabel }} {{ year + 543 }}</span>
                </template>
              </DatePicker>
            </div>
          </b-col>
          <b-col cols="2">
            <b-form-checkbox
              v-model="isAdvancedFilters"
              name="check-button"
              switch
            >
              ค้นหาขั้นสูง
            </b-form-checkbox>
          </b-col>
        </b-row>
        <div v-if="isAdvancedFilters" class="search-section">
          <b-row>
            <b-col cols="3">
              <label><strong>รูปแบบคอร์ส</strong></label>
              <b-form-select
                v-model="selectedCourseType"
                :options="courseTypeList"
              ></b-form-select>
            </b-col>
            <b-col cols="3">
              <label><strong>วิชา</strong></label>
              <b-form-select
                v-model="selectedSubject"
                :options="subjectList"
              ></b-form-select>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="3">
              <label><strong>รหัสคอร์ส</strong></label>
              <b-form-input v-model="courseCode"></b-form-input>
            </b-col>
            <b-col cols="5">
              <label><strong>ชื่อคอร์ส</strong></label>
              <v-select
                v-if="!isLoadingCourses"
                :options="courseList"
                label="courseName"
                v-model="selectedCourse"
                placeholder="พิมพ์ชื่อคอร์สเรียนที่ต้องการค้นหา"
                :clearable="false"
              />
              <v-select v-else placeholder="กำลังโหลดข้อมูล..." />
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="3">
              <label><strong>รหัสนักเรียน</strong></label>
              <b-form-input
                v-model="studentId"
                oninput="this.value = this.value.replace(/[^0-9]/g, '')"
              ></b-form-input>
            </b-col>
            <b-col cols="5">
              <label><strong>ชื่อนักเรียน</strong></label>
              <v-select
                :options="membersData"
                v-model="selectedMember"
                placeholder="พิมพ์ชื่อผู้เรียนที่ต้องการค้นหา..."
                :disabled="hasMembersData"
                :clearable="false"
              />
            </b-col>
          </b-row>
        </div>
        <b-button @click="searchQuery()" class="search-btn" variant="primary">
          <b-icon icon="search"></b-icon>
          ค้นหาข้อมูล
        </b-button>
      </div>

      <div class="table-section">
        <div class="table-title">
          <p>
            <strong>รายละเอียดสรุปประวัติการเรียน</strong> ข้อมูลทั้งหมด
            {{ learningHistorySummary.length }} ข้อมูล
          </p>
          <b-button @click="generatePdf()" variant="primary">
            <b-icon icon="chevron-double-down"></b-icon>
            ดาวน์โหลดรายงาน pdf
          </b-button>
        </div>
        <p class="remark-text">
          หมายเหตุ : ระบบทำการ generate report เป็นไฟล์ pdf
          และดาวน์โหลดลงบนเครื่องของคุณ
        </p>
        <b-table
          id="student-course-summary-list"
          :fields="fields"
          :items="sortedData"
          :per-page="perPage"
          :current-page="currentPage"
          :busy="isDataTableLoading"
          responsive
          style="font-size: 14px; border:hidden;"
          hover
          striped
          show-empty
        >
          <template slot="table-busy" class="text-center text-danger my-2">
            <Loading />
          </template>
          <template #empty>
            <p class="text-center">ไม่มีข้อมูล</p>
          </template>
        </b-table>
        <b-row class="mt-3" v-if="learningHistorySummary.length > 0">
          <b-col cols="6">
            <form class="form-inline">
              <div class="form-group mb-2">
                <label>แสดง</label>
              </div>
              <div class="form-group ml-2 mb-2">
                <b-form-select v-model="perPage" size="sm">
                  <option value="10">10</option>
                  <option value="15">15</option>
                  <option value="30">30</option>
                  <option value="50">50</option>
                </b-form-select>
              </div>
              <div class="form-group ml-2 mb-2">
                <label>
                  จาก
                  {{ learningHistorySummary.length }}
                  รายการ
                </label>
              </div>
            </form>
          </b-col>
          <b-col cols="6" v-if="learningHistorySummary.length > 0">
            <nav class="float-right">
              <b-pagination
                v-model="currentPage"
                :per-page="perPage"
                :total-rows="learningHistorySummary.length"
                aria-controls="student-course-summary-list"
                last-number
              >
              </b-pagination>
            </nav>
          </b-col>
        </b-row>
      </div>
    </div>
  </div>
</template>

<script>
import api from "@/services/api";
import vSelect from "vue-select";
import Loading from "@/components/shared/Loading";
import DatePicker from "v-calendar/lib/components/date-picker.umd";
import moment from "moment";
import dateMixin from "@/components/pages/analytics/shared/mixins/date.js";
import learningHistorySummaryReportMixin from "../../../../mixins/learning-history-summary-report-mixin";
import generateAttendanceReportPdfMixin from "../../../../mixins/generate-attendance-report-pdf-mixin";
import { mapActions, mapGetters } from "vuex";

export default {
  mixins: [
    dateMixin,
    learningHistorySummaryReportMixin,
    generateAttendanceReportPdfMixin,
  ],
  components: { vSelect, DatePicker, Loading },
  props: ["tabIndex"],
  data() {
    const currentDate = new Date();

    return {
      comId: this.$store.state.Company.companyInfo.id,
      userInfo: JSON.parse(localStorage.getItem("user")),
      moment: moment,
      dateRange: {
        start: "",
        end: "",
      },
      isAdvancedFilters: false,
      selectedCourseType: "ALL",
      courseTypeList: [
        { value: "ALL", text: "ทั้งหมด" },
        { value: "ONSITE", text: "คอร์สเรียนรอบสอนสด" },
        { value: "TRAINER", text: "คอร์สเรียนออนไลน์" },
        { value: "TRIAL", text: "คอร์สทดลองเรียน" },
      ],
      selectedSubject: "",
      subjectList: [{ value: "", text: "ทั้งหมด" }],
      courseCode: "",
      studentId: "",
      membersData: [],
      selectedMember: null,
      hasMembersData: true,
      isLoadingCourses: true,
      selectedCourse: null,
      courseList: [{ courseName: "คอร์สทั้งหมด" }],
      learningHistorySummary: [],
      perPage: 10,
      currentPage: 1,
      isDataTableLoading: false,
      isDisableDownloadReportBtn: false,
      year: currentDate.getFullYear(),
      month: currentDate.getMonth() + 1,
      thaiMonths: [
        "มกราคม",
        "กุมภาพันธ์",
        "มีนาคม",
        "เมษายน",
        "พฤษภาคม",
        "มิถุนายน",
        "กรกฎาคม",
        "สิงหาคม",
        "กันยายน",
        "ตุลาคม",
        "พฤศจิกายน",
        "ธันวาคม",
      ],
      pdfOption: {
        orientation: "l",
        format: "a4",
        unit: "px",
        lineHeight: 1.5,
        putOnlyUsedFonts: true,
      },
      pdfConfig: {
        typo: {
          header: 16,
          large: 18,
          normal: 14,
          small: 12,
          extraSmall: 10,
          chartHeader: 18,
        },
        margin: {
          t: 40,
          b: 20,
          l: 20,
          r: 20,
          tChart: 10,
          tHeaderChart: 24,
          bHeaderTable: 5,
        },
        endNormal: 12,
        endRow: 18,
        endLegend: 32,
      },
    };
  },
  computed: {
    ...mapGetters("ReportManagement", [
      "learningHistoryReportByCourse",
      "learningHistoryReportByLecture",
    ]),
    fields() {
      return [
        {
          label: "รหัสนักเรียน",
          key: "memberId",
          formatter: (value) => value || "-",
          thStyle: { whiteSpace: "nowrap" },
        },
        { label: "ชื่อนักเรียน", key: "memberName" },
        {
          label: "วันที่ลงทะเบียน",
          key: "cerStartDate",
          formatter: (value) => this.thaiDateFilter(value),
          thStyle: { whiteSpace: "nowrap" },
        },
        {
          label: "รหัสคอร์ส",
          key: "courseCode",
          formatter: (value) => value || "-",
          thStyle: { whiteSpace: "nowrap" },
        },
        { label: "ชื่อคอร์ส", key: "courseName" },

        ...(this.tabIndex === 1
          ? [
              {
                label: "ชื่อบทเรียน",
                key: "lectureName",
              },
            ]
          : []),

        {
          label: "นาทีที่ใช้ไป \n (ชั่วโมง:นาที:วินาที)",
          key: "learningTime",
          thStyle: { whiteSpace: "pre-line", textAlign: "center" },
          tdClass: "text-center",
        },
        {
          label: "รูปแบบคอร์ส",
          key: "courseFormat",
          thStyle: { whiteSpace: "nowrap" },
        },
      ];
    },
    sortedData() {
      return Object.values(this.learningHistorySummary).sort((a, b) => {
        return new Date(b.cerStartDate) - new Date(a.cerStartDate);
      });
    },
    selectedSubjectText() {
      const selected = this.subjectList.find(
        (item) => item.value === this.selectedSubject,
      );

      return selected ? selected.text : "ทั้งหมด";
    },
    formatDate() {
      return this.getFormattedRange(
        this.dateRange.start,
        this.dateRange.end,
        `calendar-range-${this.tabIndex}`,
      );
    },
    instituteName() {
      if (this.comId == 1000001) {
        return "สถาบันกวดวิชาเคมี อ.อุ๊";
      } else if (this.comId == 1000002) {
        return "สถาบันกวดวิชาแอพพลายด์ฟิสิกส์";
      } else if (this.comId == 1000003) {
        return "สถาบันกวดวิชาไบโอบีม";
      }
      return "-";
    },
    courseType() {
      if (this.selectedCourseType === "ALL") {
        return "คอร์สทั้งหมด";
      } else if (this.selectedCourseType === "ONSITE") {
        return "คอร์สเรียนรอบสอนสด";
      } else if (this.selectedCourseType === "TRAINER") {
        return "คอร์สเรียนออนไลน์";
      } else if (this.selectedCourseType === "TRIAL") {
        return "คอร์สทดลองเรียน";
      }
      return "-";
    },
    reportData() {
      if (this.tabIndex === 0) {
        return this.learningHistoryReportByCourse;
      } else {
        return this.learningHistoryReportByLecture;
      }
    },
  },
  async mounted() {
    let subjects = [];
    let courses = [];

    this.setDefaultDates();
    this.getMemberList();
    this.fetch({
      startDate: this.dateRange.start,
      endDate: this.dateRange.end,
    });

    await api.get(`/v1/courses/academic-data`).then(({ data }) => {
      subjects = data.data.subjects.map((item) => {
        return { value: item.st_id, text: item.st_name };
      });
    });
    this.subjectList.push(...subjects);

    await api.get(`v1/companies/${this.comId}/courses`).then(({ data }) => {
      courses = data.data;
      this.isLoadingCourses = false;
    });
    this.courseList.push(...courses);
  },
  methods: {
    ...mapActions("ReportManagement", [
      "fetchLearningHistoryReportByCourse",
      "fetchLearningHistoryReportByLecture",
    ]),
    async fetch(params) {
      this.isDataTableLoading = true;

      if (this.tabIndex === 0) {
        await this.fetchLearningHistoryReportByCourse(params);
        this.learningHistorySummary = this.learningHistoryReportByCourse;
        this.isDataTableLoading = false;
      }

      if (this.tabIndex === 1) {
        await this.fetchLearningHistoryReportByLecture(params);
        this.learningHistorySummary = this.learningHistoryReportByLecture;
        this.isDataTableLoading = false;
      }

      this.isDataTableLoading = false;
    },
    searchQuery() {
      let params = {
        startDate: moment(this.dateRange.start).format("YYYY-MM-DD"),
        endDate: moment(this.dateRange.end).format("YYYY-MM-DD"),
        enrollType: this.selectedCourseType,
        subjectTypeId: this.selectedSubject,
        courseCode: this.courseCode,
        cId: this.selectedCourse?.courseId
          ? this.selectedCourse?.courseId
          : null,
        studentId: this.studentId,
        studentName:
          !this.selectedMember || this.selectedMember.label === "ทั้งหมด"
            ? null
            : this.selectedMember.label,
      };

      this.fetch(params);
    },
    async getMemberList() {
      await api
        .get(`/v1/companies/${this.comId}/enrolled-members`)
        .then(({ data }) => {
          this.membersData = data.map((member) => ({
            label: member.mp_firstName + " " + member.mp_lastName,
            value: member.m_id,
          }));
          this.membersData.unshift({ label: "ทั้งหมด", value: null });
          this.hasMembersData = false;
        });
    },
    setDefaultDates() {
      const dateFormat = "YYYY-MM-DD";
      const currentDate = moment();
      const ninetyDaysAgo = moment(currentDate).subtract(90, "days");

      this.dateRange.start = ninetyDaysAgo.format(dateFormat);
      this.dateRange.end = currentDate.format(dateFormat);
    },
    getFormattedRange(startDate, endDate, calendarId) {
      if (!startDate) return "";
      moment.updateLocale("th", {});

      const rangeCalendar = document.getElementById(calendarId);
      if (rangeCalendar && rangeCalendar.style.display === "inline-block") {
        this.showCalendarRange(calendarId);
      }

      const start =
        moment(startDate).format("DD MMM ") + (moment(startDate).year() + 543);
      const end =
        moment(endDate).format("DD MMM ") + (moment(endDate).year() + 543);
      return `${start} - ${end}`;
    },
    showCalendarRange(calendarId) {
      let rangeCalendar = document.getElementById(calendarId);
      if (rangeCalendar.style.display == "inline-block") {
        rangeCalendar.style.display = "none";
      } else {
        rangeCalendar.style.display = "inline-block";
      }
    },
  },
  watch: {
    isAdvancedFilters(newValue) {
      if (!newValue) {
        (this.selectedCourseType = "ALL"),
          (this.selectedSubject = ""),
          (this.courseCode = ""),
          (this.selectedCourse = null);
      }
    },
  },
};
</script>

<style scoped lang="scss">
.date-section {
  align-items: flex-end;
}

.section-container,
.search-section {
  display: flex;
  flex-direction: column;
  gap: 40px;
}

.search-section {
  .date-range-field,
  .date-field {
    .form-control:disabled {
      background-color: #fff;
    }
  }

  .search-btn {
    width: fit-content;
  }
}

.table-section {
  display: flex;
  flex-direction: column;
  gap: 25px;

  .table-title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 10px;
  }

  .remark-text {
    color: #ffc107;
  }
}
/* Calendar */
.vc-container {
  position: absolute !important;
  right: 0 !important;
  left: initial !important;
  margin-right: 13px;
  z-index: 99;
}

/* Target the input search and its placeholder */
::v-deep .vs__search,
::v-deep .vs__search::placeholder {
  margin: 0;
  padding: 3px 3px 2px;
  font-size: 14px;
}
</style>

<style>
/* text field height */
.date-range-field .form-control,
.vs__dropdown-toggle {
  height: 38px;
}

.vs__dropdown-toggle {
  align-items: center;
}

.vs__clear {
  margin-bottom: 6px;
}

.custom-select {
  height: 38px !important;
  padding: 0 1.75rem 0 0.75rem;
  font-size: 14px !important;
}
</style>
